import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  result: undefined,
  error: undefined,
};

const change = (store, data) => {
  store.setState((state) => {
    state.developer.stamping.retencion.data = {
      ...state.developer.stamping.retencion.data,
      ...data,
    };
  });
};

const info = async (store, id) => {
  store.setState((state) => {
    state.developer.stamping.retencion.busy = true;
  });

  try {
    const data = { ...store.state.developer.stamping.retencion.data };

    const response = await Http.get(`/app/audits/timbrado/retenciones/${id}`, data);

    store.setState((state) => {
      state.developer.stamping.retencion.busy = false;
      state.developer.stamping.retencion.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.developer.stamping.retencion.busy = false;
      state.developer.stamping.retencion.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.developer.stamping.retencion = { ...initialState };
  });
};

const TimbradoRetencionInfoStore = {
  state: () => initialState,
  actions: {
    change,
    info,
    reset,
  },
};

export default TimbradoRetencionInfoStore;
